<template>
   <iframe
    src="/crtk/corre/index.html"
    style="width:100%; height:100vh; border:none;"
  />
</template>

<script>
export default {
  name: "CorreView"
}
</script>